import * as Sentry from "@sentry/vue";

export default function (app) {
    const sentryDSN = import.meta.env.VITE_SENTRY_DSN;
    if(sentryDSN){
        Sentry.init({
            app,
            dsn: sentryDSN,
            ignoreErrors: ["zaloJSV2", "reCAPTCHA Timeout", "Non-recoverable error. Do not retry."],
          });
    }
}

  
